/**
 * @title global.base.js: Sub-module of Browse feature
 * @description This module encapsulates all of the
 * functionality related to the header component.
 */
define(['dialog', 'whitelist', 'myLocation', 'header', 'nav_v2', 'footer', 'fsamodal', 'tobacco', 'ajaxmodular','CanadaGroceryDeliveryChecker','lucidworks','edd','adobeAnalyticsEvents'], function(dialog, whitelist, myLocation, header, nav_v2, footer, fsamodal, tobacco, ajaxmodular, CanadaGroceryDeliveryChecker, lucidworks,edd,adobeAnalyticsEvents) {
    /**
     * Scroll to "this" using elem as the offset and at speed
     * @param  {Object} elem  Offset element
     * @param  {number} speed The speed to scroll at in milliseconds
     * @return {jQuery}       The chainable jQuery object
     */
    jQuery.fn.scrollTo = function(elem, speed) {
      try {
      $(this).animate({
        scrollTop: $(this).scrollTop() - $(this).offset().top + $(elem).offset().top,
      }, speed == undefined ? 1000 : speed);
      } catch (e) {
        console.warn(e);
      } finally {
      return this;
      }
    };
  
    /**
     * scrollTo alternate that just uses the offset top of the element
     * @param  {Object} elem  Element to scroll to
     * @param  {number} speed The speed to scroll at in milliseconds
     * @return {jQuery}       The chainable jQuery object
     */
    jQuery.fn.scrollToElem = function(elem, speed) {
      try {
        $(this).animate({
          scrollTop: $(elem).offset().top,
        }, speed == undefined ? 1000 : speed);
      } catch (e) {
        console.warn(e);
      } finally {
        return this;
      }
    };
    /**
     * This method is actually defined in newer versions of jquery.validate
     * ($.validator.methods.destroy). Literally removes validator for the given form
     * @param  {$.validator} validator The validator to do the removing from
     * @return {jQuery}                The chainable jQuery object
     */
    jQuery.fn.destroyValidator = function(validator) {
      validator.resetForm();
      $(this).off('.validate').removeData('validator').find('.validate-equalTo-blur').off('.validate-equalTo').removeClass('validate-equalTo-blur');
      return this;
    };
    /**
     * A global ajax complete handler. This should cover common scenarios. For
     * example, session timeouts are returned as a json response from WAS with
     * errorCode 2510. In this case we want to redirect the user to the logonForm
     * so they can re-logon.
     * 
     * In case its detected that the user is already at the logon form don't do anything
     * they are already where they should be
     * 
     * @type {[type]}
     */
    $(document).ajaxComplete(function globalAjaxComplete(event, request, settings) {
      // We don't want to redirect if the request was to /navtree.
      // Changed from a straight == to indexOf to see if the request url starts with /navtree as now we are passing other
      // parameter in the call such as storeid and langid
      if (settings.url.indexOf('/navtree') === 0) return;
      
      let ajaxSessionTimeout = false;
      //Check to see if the responseJSON contain the 2510 error code associated with session timeout
      if (request && request.responseJSON && request.responseJSON.errorCode 
        && request.responseJSON.errorCode == 2510) {
          ajaxSessionTimeout = true;
          console.warn('Request '+settings.url+' Timeout');
      }
      // If an ajax call returns session timeout specific html
      if (request && request.responseText && request.responseText.toLowerCase().indexOf('session-timeout') > -1) {
          ajaxSessionTimeout = true;
          console.warn('Request '+settings.url+' Timeout');
      }
      //If it is a session timeout and we are not already at the LogonForm redirect them to LogonForm 
      if(ajaxSessionTimeout && document.location.pathname.indexOf('LogonForm') < 0 && document.location.pathname != '/') {
          let path = document.location.pathname;
          let url = path + '?_ajax';
          
          if(document.location.search && document.location.search[0] == '?'){
              url += "&" + document.location.search.substr(1);
          }				      	
          
          document.location.href = COSTCO.util.scrubSpecialChars('/LogonForm?URL=' + (COSTCO.util.isCheckout(path) ? '/CheckoutCartView' : url));
      }
      return;
    });
    /**
     * A global ajax error handler. This should cover common scenarios. For
     * example if any ajax request returns a ReLogonFormView response, we should
     * direct the user to logon.
     */
    $(document).ajaxError(function globalAjaxError(event, jqxhr, settings, thrownError) {
      if (document.location.hostname != 'www.costco.com' && document.location.hostname != 'www.costco.ca') {
        console.error(`${thrownError} calling ${settings.url}`);
      }
    });
    let GlobalBase = {
      notify: function(eventName) {
        COSTCO.Global.logger('Firing Event: ' + eventName);
        let event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
        document.dispatchEvent(event);
      },
      logger: function(message) {
        if (typeof(this.logQueue) == 'undefined') {
          this.logQueue = [];
        }
        this.logQueue.push(message);
        console.log(message);
      },
      initPrinting: function() {
        $('.print-link').click(function() {
          window.print();
        });
      },
      /** Initialize button to perform click when keydown = enter**/
      initButtonAda: function() {
        $('input:button').keydown(function(event) {
          if (event.which == 13){
            this.click();
            event.stopPropagation();
            event.preventDefault();
          }
        });
        //firefox sometime has issue to resolve enter as an onclick event for a
        if (typeof InstallTrigger !== 'undefined') {
          $('a[aria-haspopup!=true], a:not([aria-haspopup])').keydown(function(event) {
              if (event.which == 13)
                this.click();
          });
        }
  
      },
      setCellCookie: function() {
        if (window.location.href.indexOf('cell=1') > -1) {
          $.cookie('cell', 1);
        }
        if (window.location.href.indexOf('cell=2') > -1) {
          $.cookie('cell', 2);
        }
        if (window.location.href.indexOf('cell=3') > -1) {
          $.cookie('cell', 3);
        }
        if (window.location.href.indexOf('cell=4') > -1) {
          $.cookie('cell', 4);
        }        
      },
      /**
       * Bootstrap comes with "Tabs" See:
       * https://getbootstrap.com/docs/3.3/components/#nav-tabs
       * Typically, the functionality works natively with ul/li elements. However,
       * in situations where you may have many "tabs", li's end up wrapping to the
       * next line. Changing the tabs to a table/cell structure allows them
       * to remain on a single line. This function supplements the native behavior
       * of clearing the active state on those cells.
       * Look for .costco-tabs-alternate for an example
       * @return {void}
       */
      costcoTableTabs: function() {
          $('.costco-tabs-alternate .table-cell a').unbind('click').on('click', function(e) {
            let $activeCell = $(this).parent();
            $activeCell.parents('.costco-tabs-alternate').find('.table-cell').removeClass('active');
            $activeCell.addClass('active');
          });
        },
      
      /**
       * update selectedMenuItem option in session storage for React My account Nav highlight selected option
       */
      updateSelectedMenuItem : function(option) {
           window.sessionStorage.setItem('selectedMenuItem', option); 
      },
  
      pageSizeCheck: function(e) {
          e.preventDefault();
          let url=document.getElementById("newAddressLine").getAttribute("href");;
          if(window.innerWidth > 768 && window.innerWidth < 1025){
              pageSize=8;
              if(url.indexOf("storeId") !== -1){
                  url=url+"&pageSize="+pageSize;
              }
              else{
                  url=url+"?pageSize="+pageSize;
              }
          }
          window.location.href=url;
      },
      
      /**
       * Initialize focus out event for new redesigned (v2) input fields
       */
      initInputFieldsV2: function() {
     
          $(".input-field-v2 .input-outline").each(function( index ) {
              if( $(this).attr('value') !== undefined && $(this).attr('value') !== "" ){
                 $('label[for="' + $(this).attr('id') + '"]').addClass( "active" );
                 if (!$(this).hasClass("error") && !$(this).hasClass("completed")) {
                     $(this).addClass("completed");
                 }
              }
          });
          
          $('body').on("focusout", ".input-field-v2 .input-outline", function (element) {
             if (!element.target.value && !element.target.placeholder){
                  $("label[for='" + $(element.target).attr('id') + "']").removeClass("active");
                  if ($(element.target).hasClass("completed")) {
                      $(element.target).removeClass("completed");
                  }
              } else {
                  $("label[for='" + $(element.target).attr('id') + "']").addClass("active");
                  if (!$(element.target).hasClass("error") && !$(element.target).hasClass("completed")) {
                      $(element.target).addClass("completed");
                  }
              }	 
          });	
      },
      
      initMultilineDropboxSelectionV2: function() {
          
          $('body').on("click", ".multiline-dropbox-selection-v2 button", function () {
              
              var selectedOptionId = $(this).find('a').attr('data-option-id');
              
              var optionValues = $('.multiline-dropbox-selection-v2 li');
              
              $.each(optionValues, function(index, optionValue){
                  if($(optionValue).find('a').attr('data-option-id') == selectedOptionId) {
                      $(optionValue).hide();
                  }else {
                      $(optionValue).show();
                  }
              }); 
          });
          
          $('body').on("click", ".multiline-dropbox-selection-v2 li", function () {
              
              var ul = $(this).parent();
              var div = $(ul).parent();
              var button = $(div).find('.dropdown-toggle');
              var input = $(div).find('.multiline-dropbox-selected-option');
              
              $(button).html( $(this).find('a').clone());
              $(input).val($(this).find('a').attr('data-option-id'));
          });
          
      },
      
      /**
       * Initialize focus out event for new redesigned (v2) input fields
       */
      initSelectFieldsV2: function() {
     
          $("select.input-outline").each(function( index ) {
              if(this.value !== undefined && this.value !== "" ){
                    $('label[for="' + $(this).attr('id') + '"]').addClass( "active" );
              }
          });
     
          $('body').on("focusout", "select.input-outline", function (element) {
              if (!element.target.value){
                  $("label[for='" + $(element.target).attr('id') + "']").removeClass("active");
              } else {
                  $("label[for='" + $(element.target).attr('id') + "']").addClass("active");
              }
          });
      },
  
      /**
       * Register change event for new redesigned (v2) datePicker input
       */
      datePickerEventHanler: function() {
        if ('.preferred-arrival-date-v2') {
          $(".preferred-arrival-date-v2").each(function() {
            let selector = $(this).find('input.date-input');
            selector.change(function () {
              if ($(this).val() !== '') {
                $(this).parent().find('.label-outline').addClass('active')
              } else {
                $(this).parent().find('.label-outline').removeClass('active');
              }
            });
          });
        }
      },
      
      /**
       * Register change event for new redesigned (v2) radio button datePicker input
       */
      radioButtonDatePickerEventHanler: function() {
        if ('#deldatepicker-div') {
          $("#deldatepicker-div").find('input.date-input').each(function() {
              $(this).change(function () {
              if ($(this).val() !== '') {
                $(this).parent().find('.label-outline').addClass('active')
              } else {
                $(this).parent().find('.label-outline').removeClass('active');
              }
            });
          });
        }
      },
      /**
       * Initialize events on back to top links
       * by finding them by class names that are
       * used for describing this elements
       */
      initBackToTopLinks: function(){
          if ($('#headerskip').length > 0) {
        	  if(window.location.href.indexOf("myaccount/") > -1){
    	         COSTCO.util.setEventOnBackToTopLinkGatsby(".skip-main");
        	  }  
              let backToTopClasses = [".back-to-top", ".back-to-top-button", ".back-to-top-refills", ".back_to_top", ".back-to-top-inline", ".drug_detail_back_to_top", ".back-to-top-ada"];
              backToTopClasses.forEach(element => COSTCO.util.setEventOnBackToTopLink(element));
          }
      },
      
      /**
       * Function called to run things that require the window to be loaded
       * for it to run. This is introduced as there was a discreprency for chrome
       * in terms of window on load and document ready
       */
      initOnLoad: function() {
        COSTCO.Header.align_quickbuy_btn();
        //Call to set zipcode via IP Sniffer
        if(COSTCO.util.isBusinessDelivery()){
            COSTCO.Header.setBDZipCodeFromAkamai();
        } else{
            COSTCO.Header.manageGroceryZipCode(); 
        }
        myLocation.init();
        COSTCO.util.safe(COSTCO.Header.setup_nav_dropdown)();
        COSTCO.Header.updateSamedayLinks();
        COSTCO.Global.initInputFieldsV2();
        COSTCO.Global.initSelectFieldsV2();
  
        COSTCO.Global.initMultilineDropboxSelectionV2();
        COSTCO.Global.datePickerEventHanler();
        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
          COSTCO.Global.radioButtonDatePickerEventHanler();
        }
        COSTCO.Global.initBackToTopLinks();
        $('body').on('inserted.bs.popover',COSTCO.Header.updateSamedayLinks);
        
        // (BD only) If WC_BD_ZIP cookie exists, WC_BD_LOC cookie should also exist in format City|ST|CC - populate it if it doesn't
        if (COSTCO.util.isBusinessDelivery() && $.cookie('WC_BD_ZIP') && !/^.+\|\w{2}\|\w{2}$/ig.test($.cookie('WC_BD_LOC'))) {
            if ($('#isGeocodeService').val() != "true") {
                COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
            } else {
                COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
            }
        }
      },
      init: function() {
        COSTCO.Global.logger('Costco Global Object Initialized: ' + window.location);
        if ($('#isLozadLazyEnabled').val() == "true") {
            const imgResponsiveEle=document.querySelectorAll('img[data-src].img-responsive');
			const lozadObserver = lozad(imgResponsiveEle); 
			lozadObserver.observe();
        }else {
            $('img').unveil(400);
        }    
       
        whitelist.init();
        fsamodal.init();
        header.init();
        footer.init();
        if(COSTCO.util.isBDStore()){
            tobacco.init();
        }
        COSTCO.Global.initPrinting();
        COSTCO.Global.initButtonAda();
        COSTCO.util.iosPositionFix();
        this.costcoTableTabs();
        COSTCO.Global.notify('CostcoGlobalLoaded');
        costcoloadstate.modules = true;
        if (document.readyState == 'complete') {
          COSTCO.Global.notify('CostcoSubModulesLoaded');
          COSTCO.Global.initOnLoad();
          costcoloadstate.submodules = true;
        } else {
        	$(window).on('load', function() {
            COSTCO.Global.notify('CostcoSubModulesLoaded');
            costcoloadstate.submodules = true;
            COSTCO.Global.initOnLoad();
          });
        }
        COSTCO.Global.setCellCookie();
        lucidworks.init();
        COSTCO.util.addAriaHiddenToHiddenInput();
      }
    };

    return GlobalBase;
  });


// WEBPACK FOOTER //
// ./js/global/global.base.js